export const rooms = [
  {
    id: 1,
    name: "Deluxe King Room",
    category: "deluxe",
    price: 189,
    size: 45,
    capacity: 2,
    beds: "1 King Bed",
    view: "City View",
    rating: 4.8,
    reviews: 124,
    image: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80",
      "https://images.unsplash.com/photo-1631049552057-403cdb8f0658?w=800&q=80",
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&q=80",
    ],
    description: "Our Deluxe King Room offers a sophisticated retreat with a plush king-sized bed, panoramic city views, and modern amenities. Ideal for business travelers and couples seeking a luxurious stay.",
    amenities: ["Free WiFi", "Air Conditioning", "Flat-screen TV", "Minibar", "Safe", "Room Service"],
    featured: true,
  },
  {
    id: 2,
    name: "Superior Twin Room",
    category: "superior",
    price: 159,
    size: 38,
    capacity: 2,
    beds: "2 Twin Beds",
    view: "Garden View",
    rating: 4.6,
    reviews: 89,
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80",
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80",
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&q=80",
    ],
    description: "The Superior Twin Room is perfect for friends or colleagues traveling together. With two plush twin beds and serene garden views, it provides comfort and style in equal measure.",
    amenities: ["Free WiFi", "Air Conditioning", "Flat-screen TV", "Tea/Coffee Maker", "Safe", "Bathrobe"],
    featured: false,
  },
  {
    id: 3,
    name: "Junior Suite",
    category: "suite",
    price: 289,
    size: 65,
    capacity: 2,
    beds: "1 King Bed",
    view: "Ocean View",
    rating: 4.9,
    reviews: 201,
    image: "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=800&q=80",
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80",
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&q=80",
    ],
    description: "The Junior Suite offers a separate living area with stunning ocean views. Enjoy the luxury of a premium king bed, whirlpool bathtub, and personalized butler service.",
    amenities: ["Free WiFi", "Butler Service", "Whirlpool Bath", "Minibar", "Living Area", "Ocean View Balcony"],
    featured: true,
  },
  {
    id: 4,
    name: "Presidential Suite",
    category: "suite",
    price: 689,
    size: 120,
    capacity: 4,
    beds: "1 King + 1 Queen",
    view: "Panoramic View",
    rating: 5.0,
    reviews: 67,
    image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80",
      "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=800&q=80",
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&q=80",
    ],
    description: "Our Presidential Suite is the pinnacle of luxury — a 120sqm sanctuary featuring panoramic views, a private dining room, gourmet kitchen, and exclusive access to the executive lounge.",
    amenities: ["Private Butler", "Gourmet Kitchen", "Private Dining", "Jacuzzi", "Home Theatre", "Executive Lounge"],
    featured: true,
  },
  {
    id: 5,
    name: "Classic Double Room",
    category: "classic",
    price: 129,
    size: 32,
    capacity: 2,
    beds: "1 Double Bed",
    view: "City View",
    rating: 4.4,
    reviews: 156,
    image: "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&q=80",
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80",
    ],
    description: "The Classic Double Room is a comfortable and elegant choice for travelers seeking quality at value. Features a cozy double bed, en-suite bathroom, and all essential modern amenities.",
    amenities: ["Free WiFi", "Air Conditioning", "Flat-screen TV", "Tea/Coffee Maker", "Private Bathroom"],
    featured: false,
  },
  {
    id: 6,
    name: "Family Suite",
    category: "suite",
    price: 399,
    size: 85,
    capacity: 5,
    beds: "1 King + 2 Twin",
    view: "Garden View",
    rating: 4.8,
    reviews: 93,
    image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800&q=80",
      "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80",
    ],
    description: "Designed for families, our Family Suite features a master bedroom with king bed and a separate children's room with twin beds, a spacious living area, and an enclosed garden terrace.",
    amenities: ["Free WiFi", "Kids Play Area", "Kitchenette", "Living Room", "Garden Terrace", "Baby Cot"],
    featured: true,
  },
];

export const amenities = [
  { icon: "FaSwimmingPool", title: "Infinity Pool", description: "Rooftop infinity pool with panoramic city views, open year-round." },
  { icon: "FaSpa", title: "Luxury Spa", description: "Full-service spa offering massages, facials, and wellness treatments." },
  { icon: "FaDumbbell", title: "Fitness Center", description: "State-of-the-art equipment, personal trainers available 24/7." },
  { icon: "FaUtensils", title: "Fine Dining", description: "Award-winning restaurant serving international and local cuisine." },
  { icon: "FaWifi", title: "High-Speed WiFi", description: "Complimentary high-speed internet throughout the property." },
  { icon: "FaConciergeBell", title: "Concierge", description: "24-hour concierge service for tours, reservations, and more." },
  { icon: "FaCar", title: "Valet Parking", description: "Complimentary valet parking for all hotel guests." },
  { icon: "FaGlassMartiniAlt", title: "Sky Bar", description: "Rooftop cocktail bar with live music every evening." },
];

export const testimonials = [
  {
    id: 1,
    name: "Emily Richardson",
    location: "New York, USA",
    rating: 5,
    comment: "An absolutely breathtaking experience. The staff went above and beyond to make our anniversary unforgettable. The Presidential Suite was pure magic!",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80",
    date: "March 2024",
  },
  {
    id: 2,
    name: "James Thornton",
    location: "London, UK",
    rating: 5,
    comment: "The finest hotel I've stayed at in over 20 years of business travel. The service is impeccable, the rooms are exquisite, and the dining is world-class.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80",
    date: "February 2024",
  },
  {
    id: 3,
    name: "Sofia Mendez",
    location: "Barcelona, Spain",
    rating: 5,
    comment: "We brought our family here for a vacation and it exceeded every expectation. The Family Suite was spacious, the pool was stunning, and our kids loved it!",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80",
    date: "January 2024",
  },
  {
    id: 4,
    name: "Hiroshi Tanaka",
    location: "Tokyo, Japan",
    rating: 5,
    comment: "From the moment we arrived, every detail was perfect. The spa treatments were rejuvenating and the ocean view from our suite was absolutely spectacular.",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&q=80",
    date: "December 2023",
  },
];

export const galleryImages = [
  { id: 1, src: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&q=80", category: "exterior", title: "Hotel Exterior" },
  { id: 2, src: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80", category: "rooms", title: "Deluxe Room" },
  { id: 3, src: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80", category: "pool", title: "Infinity Pool" },
  { id: 4, src: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80", category: "dining", title: "Fine Dining" },
  { id: 5, src: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80", category: "spa", title: "Luxury Spa" },
  { id: 6, src: "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=800&q=80", category: "rooms", title: "Suite Interior" },
  { id: 7, src: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80", category: "exterior", title: "Hotel Lobby" },
  { id: 8, src: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=800&q=80", category: "pool", title: "Pool Area" },
  { id: 9, src: "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800&q=80", category: "dining", title: "Restaurant" },
  { id: 10, src: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80", category: "rooms", title: "Presidential Suite" },
  { id: 11, src: "https://images.unsplash.com/photo-1560185127-6ed189bf02f4?w=800&q=80", category: "spa", title: "Spa & Wellness" },
  { id: 12, src: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800&q=80", category: "rooms", title: "Family Suite" },
];

export const specialOffers = [
  {
    id: 1,
    title: "Honeymoon Package",
    subtitle: "Romance Awaits",
    description: "Celebrate your love with our exclusive honeymoon package — includes a suite upgrade, couples' spa treatment, candlelit dinner, and champagne on arrival.",
    discount: "25% OFF",
    price: 599,
    originalPrice: 799,
    validUntil: "Dec 31, 2024",
    image: "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=800&q=80",
    badge: "Popular",
    includes: ["Suite Upgrade", "Couples Spa", "Candlelit Dinner", "Champagne", "Late Checkout"],
  },
  {
    id: 2,
    title: "Family Getaway",
    subtitle: "Create Memories Together",
    description: "The perfect family escape. Our family package includes connecting rooms, kids' club access, breakfast for all, and a guided family excursion.",
    discount: "20% OFF",
    price: 479,
    originalPrice: 599,
    validUntil: "Nov 30, 2024",
    image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800&q=80",
    badge: "Best Value",
    includes: ["Connecting Rooms", "Kids Club", "Family Breakfast", "Guided Tour", "Pool Access"],
  },
  {
    id: 3,
    title: "Business Executive",
    subtitle: "Work in Luxury",
    description: "Our executive package is designed for the modern business traveler — airport transfer, meeting room access, daily breakfast, and express laundry service.",
    discount: "15% OFF",
    price: 349,
    originalPrice: 410,
    validUntil: "Ongoing",
    image: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80",
    badge: "Business",
    includes: ["Airport Transfer", "Meeting Room", "Daily Breakfast", "Express Laundry", "Lounge Access"],
  },
];

export const faqs = [
  { question: "What is the check-in and check-out time?", answer: "Check-in is at 3:00 PM and check-out is at 12:00 PM (noon). Early check-in and late check-out may be available upon request, subject to availability." },
  { question: "Is breakfast included in the room rate?", answer: "Breakfast inclusion varies by room type and package. Please check the specific room details or contact our reservations team to confirm." },
  { question: "Do you offer airport shuttle services?", answer: "Yes, we offer complimentary airport shuttle service for guests staying in our suite categories. For other room types, transfers can be arranged at an additional cost." },
  { question: "What is your cancellation policy?", answer: "Cancellations made 48 hours or more before arrival receive a full refund. Cancellations within 48 hours are subject to a one-night charge." },
  { question: "Are pets allowed at the hotel?", answer: "We welcome small pets (under 10kg) in select room categories for an additional fee of $50/night. Please inform us at booking." },
  { question: "Do you have facilities for guests with disabilities?", answer: "Absolutely. We have wheelchair-accessible rooms, ramps, elevators, and dedicated staff assistance available 24/7 for guests with special needs." },
  { question: "Is there parking available?", answer: "Yes, we offer complimentary valet parking for all hotel guests. Self-parking is also available for day visitors at $20/day." },
  { question: "Can I host events or weddings at the hotel?", answer: "We have elegant event spaces and dedicated event planning teams for weddings, corporate events, and private functions. Contact our events team for details." },
];

export const services = [
  { icon: "FaConciergeBell", title: "24/7 Concierge", description: "Our dedicated concierge team is available around the clock to assist with reservations, tours, and any special requests." },
  { icon: "FaSpa", title: "Luxury Spa", description: "Rejuvenate your body and mind with a comprehensive range of spa treatments, massages, and wellness therapies." },
  { icon: "FaUtensils", title: "Fine Dining", description: "Experience culinary excellence at our award-winning restaurant, featuring seasonal menus crafted by world-class chefs." },
  { icon: "FaSwimmingPool", title: "Infinity Pool", description: "Our rooftop infinity pool offers stunning panoramic views and a serene escape from the city below." },
  { icon: "FaDumbbell", title: "Fitness Center", description: "Maintain your wellness routine in our fully equipped 24-hour gym with personal training sessions available." },
  { icon: "FaCar", title: "Airport Transfer", description: "Start and end your journey in comfort with our luxury fleet and professional drivers available 24 hours." },
  { icon: "FaBriefcase", title: "Business Center", description: "State-of-the-art business center with meeting rooms, high-speed internet, and full secretarial support." },
  { icon: "FaBaby", title: "Kids Club", description: "A safe, fun-filled environment for our youngest guests with supervised activities and entertainment programs." },
];
